import angular from 'angular';
import mycrmSlider from './mycrmSlider';
import './style.scss';

export default angular
  .module('components.mycrmSlider', [])
  .component('mycrmSlider', mycrmSlider).name;
